import { useState } from 'react';
import SeedFormModal from './SeedFormModal';
import ConfirmModal from './ConfirmModal';

export default function SeedManager({ seeds, onAddSeed, onUpdateSeed, onDeleteSeed, onAddVariety, onOpenCalendar, onBack }) {
  const [formOpen, setFormOpen] = useState(false);
  const [editingSeed, setEditingSeed] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedSeedId, setExpandedSeedId] = useState(null);
  const [newVarietyNames, setNewVarietyNames] = useState({});
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [seedToDelete, setSeedToDelete] = useState(null);

  const handleEdit = (seed) => {
    setEditingSeed(seed);
    setFormOpen(true);
  };

  const handleAdd = () => {
    setEditingSeed(null);
    setFormOpen(true);
  };

  const handleSave = (seedData) => {
    if (editingSeed) {
      onUpdateSeed(seedData);
    } else {
      onAddSeed(seedData);
    }
    setFormOpen(false);
  };

  const handleVarietyInputChange = (seedId, value) => {
    setNewVarietyNames(prev => ({ ...prev, [seedId]: value }));
  };

  const filteredSeeds = seeds.filter(s => s.name.toLowerCase().includes(searchTerm.toLowerCase()));


  return (
    <div className="huerto-container animate-fade">
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Gestionar Semillas</h2>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
        <button className="btn" onClick={handleAdd} style={{ flex: 1 }}>
          ➕ Añadir Nueva Semilla
        </button>
        <button className="btn-secondary" onClick={onOpenCalendar} style={{ flex: 1 }}>
          📅 Calendario
        </button>
      </div>

      <div className="input-group mb-4">
        <input 
          type="text" 
          placeholder="🔍 Buscar semilla..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ padding: '10px 16px' }}
        />
      </div>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        <div className="seeds-manager-list">
          {filteredSeeds.map((seed) => (
            <div key={seed.id} className="seed-manager-item" style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
              <div style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }} onClick={() => setExpandedSeedId(expandedSeedId === seed.id ? null : seed.id)}>
                <div className="seed-icon">{seed.icon}</div>
                <div className="seed-info" style={{ flex: 1 }}>
                  <div style={{ fontWeight: 'bold' }}>{seed.name}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Distancia: {seed.distanceCm} cm</div>
                  {seed.calendar && (
                    <div style={{ display: 'flex', gap: '2px', marginTop: '6px' }}>
                      {['E','F','M','A','M','J','J','A','S','O','N','D'].map((letter, mIndex) => {
                        const hasPlanting = seed.calendar[mIndex] && seed.calendar[mIndex].length > 0;
                        return (
                          <div 
                            key={mIndex} 
                            style={{ 
                              width: '14px', height: '14px', borderRadius: '2px', 
                              backgroundColor: hasPlanting ? 'var(--primary-color)' : 'rgba(255,255,255,0.1)',
                              color: hasPlanting ? '#fff' : '#666',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '8px', fontWeight: 'bold'
                            }}
                          >
                            {letter}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '8px' }} onClick={e => e.stopPropagation()}>
                  <button 
                    onClick={() => handleEdit(seed)}
                    style={{ background: 'transparent', border: 'none', color: 'var(--primary-color)', cursor: 'pointer', fontSize: '18px' }}
                    title="Editar"
                  >
                    ✏️
                  </button>
                  <button 
                    onClick={() => {
                      setSeedToDelete(seed);
                      setConfirmDeleteOpen(true);
                    }}
                    style={{ background: 'transparent', border: 'none', color: 'var(--danger-color)', cursor: 'pointer', fontSize: '18px' }}
                    title="Borrar"
                  >
                    🗑️
                  </button>
                </div>
              </div>

              {expandedSeedId === seed.id && (
                <div style={{ marginTop: '12px', paddingLeft: '40px', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '12px' }}>
                  <h4 style={{ margin: '0 0 8px 0', fontSize: '14px' }}>Variedades:</h4>
                  {seed.varieties && seed.varieties.length > 0 ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '12px' }}>
                      {seed.varieties.map(v => (
                        <span key={v} style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>
                          {v}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p style={{ margin: '0 0 12px 0', fontSize: '12px', color: 'var(--text-secondary)' }}>No hay variedades.</p>
                  )}
                  
                  <div style={{ display: 'flex', gap: '8px' }} onClick={e => e.stopPropagation()}>
                    <input 
                      type="text" 
                      placeholder="Nueva variedad..." 
                      value={newVarietyNames[seed.id] || ''}
                      onChange={(e) => handleVarietyInputChange(seed.id, e.target.value)}
                      style={{ padding: '6px 10px', fontSize: '14px', flex: 1, backgroundColor: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '4px', color: '#fff' }}
                    />
                    <button 
                      className="btn" 
                      style={{ padding: '6px 12px', fontSize: '14px' }}
                      onClick={() => {
                        const val = newVarietyNames[seed.id];
                        if (val && val.trim()) {
                          onAddVariety(seed.id, val.trim());
                          setNewVarietyNames(prev => ({ ...prev, [seed.id]: '' }));
                        }
                      }}
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <SeedFormModal 
        isOpen={formOpen} 
        onClose={() => setFormOpen(false)} 
        onSave={handleSave} 
        seed={editingSeed} 
      />

      <ConfirmModal
        isOpen={confirmDeleteOpen}
        title="Eliminar Semilla"
        message={seedToDelete ? `¿Seguro que quieres eliminar la semilla "${seedToDelete.name}"? Esta acción no se puede deshacer.` : ''}
        confirmText="Eliminar"
        cancelText="Cancelar"
        onConfirm={() => {
          if (seedToDelete) {
            onDeleteSeed(seedToDelete.id);
          }
          setConfirmDeleteOpen(false);
          setSeedToDelete(null);
        }}
        onCancel={() => {
          setConfirmDeleteOpen(false);
          setSeedToDelete(null);
        }}
        icon="🗑️"
      />
    </div>
  );
}
